<template>
    <el-container direction="vertical" class="card" v-loading="loading">
        <el-row class="card-header">
            <el-col :span="16">
                <div class="page-title bold fnt-lg dark text-left">
                    Карточка компании
                </div>
            </el-col>
            <el-col :span="8" class="actions">
                <span class="action-title action-edit" @click="save" v-if="canEdit">
                    {{ saveBtnText }}
                </span>
                <span class="action-title action-close" @click="close">
                    Отменить
                </span>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="7" justify="start" class="card-general">
                <el-form :model="company" label-position="top">
                    <el-row>
                        <el-col :span="24" justify="start">
                            <div class="input-label">
                                Компания
                            </div>
                            <div :class="{ 'error-input': errors.name }">
                                <el-input v-model="company.name" size="mini" autocomplete="off" />
                                <div class="error" v-if="errors.name">
                                    {{ errors.name[0] }}
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24" :class="{ 'error-input': errors.phone }">
                            <div class="input-label">
                                Телефон
                            </div>
                            <div class="el-input el-input--mini">
                                <the-mask v-model="company.phone" mask="+# (###) ###-##-##" placeholder="+7 (495) 123-45-67" class="el-input__inner" />
                            </div>
                            <div class="error" v-if="errors.phone">
                                {{ errors.phone[0] }}
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24" :class="{ 'error-input': errors.email }">
                            <div class="input-label">
                                E-mail
                            </div>
                            <el-input size="mini" autocomplete="off" v-model="company.email" />
                            <div class="error" v-if="errors.email">
                                {{ errors.email[0] }}
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24" :class="{ 'error-input': errors.address }">
                            <div class="input-label">
                                Адрес
                            </div>
                            <address-autocomplete class="autocomplete-input" v-model="company.address" />
                            <div class="error" v-if="errors.address">
                                {{ errors.address[0] }}
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
            </el-col>
            <el-col :span="16" class="card-comment" :class="{ 'error-input': errors.comment }">
                <div class="input-label">
                    Комментарий
                </div>
                <el-input
                    size="mini"
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    placeholder=""
                    v-model="company.comment"
                />
                <div class="error" v-if="errors.comment">
                    {{ errors.comment[0] }}
                </div>
            </el-col>
        </el-row>
    </el-container>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import '../../../assets/styles/card.scss';
import AddressAutocomplete from '@/components/AddressAutocomplete';
library.add(faCheck);

export default {
    name: 'CompaniesCardEdit',
    props: {
        id: {
            type: [String, Number],
            default: 0
        }
    },
    components: {
        AddressAutocomplete: AddressAutocomplete
    },
    data() {
        return {
            company: {
                id: null,
                name: null,
                phone: null,
                email: null,
                address: null
            },
            loading: true,
            errors: {}
        };
    },
    async beforeMount() {
        if (!this.isNew) {
            this.loading = true;
            try {
                const response = await this.$store.dispatch('companies/getCompany', this.id);
                this.company = response.data.data;
                this.loading = false;
            } catch (error) {
                if (error.response.status === 403 || error.response.status === 400) {
                    console.log(error.response.data.error);
                    this.loading = false;
                    this.$router.go(-1);
                }
            } finally {
                this.loading = false;
            }
        } else {
            this.loading = false;
        }
    },
    computed: {
        isNew() {
            return +this.id === 0;
        },
        saveBtnText() {
            return +this.id === 0 ? ' Создать ' : 'Применить';
        },
        canEdit() {
            const approvedRoles = this.$store.getters['references/rolesBySectionCompanies'];
            if (approvedRoles.indexOf('companies_read') !== -1) {
                approvedRoles.splice(approvedRoles.indexOf('companies_read'), 1);
            }
            const roles = this.$store.state.auth.roles;
            const intersection = Object.keys(roles).filter(x => approvedRoles.includes(x));
            return intersection.length > 0;
        }
    },
    methods: {
        save() {
            this.loading = true;
            const action = this.isNew ? 'createCompany' : 'updateCompany';
            this.$store.dispatch('companies/' + action, this.company).then(
                response => {
                    this.loading = false;
                    if (response.data.success) {
                        this.$router.push({ name: 'company-card', params: { id: '' + response.data.data.id } });
                    } else {
                        this.errors = response.data.data;
                    }
                },
                error => {
                    if (error.response.status !== 422) {
                        console.log(error.response.data.error);
                        this.loading = false;
                        this.$router.go(-1);
                    } else {
                        this.errors = error.response.data.errors;
                    }
                }
            ).finally(() => { this.loading = false; });
        },
        close() {
            if (this.isNew) {
                this.$router.go(-1);
            } else {
                this.$router.push({ name: 'company-card', params: { id: '' + this.id } });
            }
        }
    }
};
</script>
